import React from "react";
import moment from "moment";
import { formatDate } from "../../helpers/FunctionHelpers";


const Rating = (cell:any) => {
  return (
    <React.Fragment>
      <span>
        <span className="badge bg-light text-body fs-12 fw-medium">
          <i className="mdi mdi-star text-warning me-1"></i>{cell.getValue()}
        </span>
      </span>
    </React.Fragment>
  );
};

const Published = (cell:any) => {
  return (
    <React.Fragment>
      <span className="text-center">
        {formatDate(cell.getValue())}
        {/* <small className="text-muted ms-1">{handleValidTime(cell.getValue())}</small> */}
      </span>
    </React.Fragment>
  );
};

const Price = (cell:any) => {
  return (
    <React.Fragment>
      {"₹ " + cell.getValue() + ".00"}
    </React.Fragment>
  );
};

export { Rating, Published, Price };
